/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const root = (typeof window !== "undefined") ? window : globalThis;

root.initWelcomeForm = function(el) {
  const $el = $(el);
  return $el.find('.submit').click(() => startLoader($el));
};


root.initWelcomeForms = function() {
  initWelcomeForm($('#welcome_sms'));
  return initWelcomeForm($('#welcome_username'));
};

/*
$(function() {
  if ($('.welcome').length) {
    return initWelcomeForms();
  }
});
*/

function initWelcomeOnLoad() {
  if ($('.welcome').length) {
    return initWelcomeForms();
  }
}

$(initWelcomeOnLoad);
document.addEventListener('turbo:load', initWelcomeOnLoad);
